<app-menu-right></app-menu-right>

<app-topbar></app-topbar>

<app-menu-left></app-menu-left>

<div class="content">
	<app-titles></app-titles>
	<router-outlet></router-outlet>
</div>

<app-footer></app-footer>
